export const getTemplatesByType = async (type: string) => {
  const response = await window.fetch(`/admin/printtemplates/${type}`);
  const json = await response.json();
  return json;
};
